import React, { useState, useContext } from "react";
import "./CreateCategory.css";
import AuthContext from "../store/auth-context";

function CreateCategory(props) {
  const [enteredTitle, setEnteredTitle] = useState("");
  const [counter, setCounter] = useState(0);
  const authCtx = useContext(AuthContext);

  function createDbCategory() {
    const url =
      "https://budgetmaster-1b6a5-default-rtdb.firebaseio.com/users/" +
      authCtx.localId +
      "/expenses.json?auth=" +
      authCtx.token;
    fetch(url, {
      method: "POST",
      body: JSON.stringify({
        title: enteredTitle,
        expenses: [],
      }),
      header: { "Content/type": "application/json" },
    }).then(() => {});
  }

  function submitHandler(event) {
    event.preventDefault();
    var category = {
      title: enteredTitle,
      id: counter,
      expenses: [],
      total: 0,
      setTotal: function (t) {
        this.total = t;
      },
    }; //every category has a total that is edited using a function
    props.onAddExpense(category); //Add to category array
    createDbCategory();
    setEnteredTitle("");
  }

  function titleChangeHandler(event) {
    setEnteredTitle(event.target.value);
  }
  return (
    <div className="container addCat">
      <div className="row">
        <div className="addCategory">
          <form onSubmit={submitHandler}>
            <div className="form-group">
              <label className="catLab">Category name</label>
              <p className="createCategoryI">
                <input
                  required
                  class="form-control createCategoryInput"
                  placeholder="Housing"
                  type="text"
                  value={enteredTitle}
                  onChange={titleChangeHandler}
                ></input>
              </p>
            </div>
            <div className="catSubmitDiv">
              <br></br>
              <br></br>
              <button type="submit" className="btn btn-primary mb-2 catSubmit">
                Submit
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}

export default CreateCategory;
